import { ProcessoPlanejamento } from 'src/app/classes/ProcessoPlanejamento';
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import { UiModalComponent } from "src/app/theme/shared/components/modal/ui-modal/ui-modal.component";
import { PlanejamentoService } from "src/app/services/planejamento.service";
import { CultivarService } from "src/app/services/cultivar.service";
import { CulturaService } from "src/app/services/cultura.service";
import { UtilsService } from "src/app/utils/utils.service";
import Swal from 'sweetalert2';
import { StorageService } from "src/app/services/storage.service";
import { Cultura } from "src/app/classes/Cultura";
import { Planejamento } from "src/app/classes/Planejamento";
import { EtapaService } from "src/app/services/etapa.service";
import { ProcessoPlanejamentoService } from 'src/app/services/processo-planejamento.service';
import { AuxEtapa } from 'src/app/classes/auxiliar/AuxEtapa';

@Component({
  selector: "app-talhoes",
  templateUrl: "./talhoes.component.html",
  styleUrls: ["./talhoes.component.scss"],
})
export class TalhoesComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild("ModalTalhoes", { static: false }) ModalTalhoes: UiModalComponent;
  @ViewChild('modalConfirmacaoLimpeza', { static: false }) modalConfirmacaoLimpeza: any;


  @Input() anoSafraId: number;
  @Input() fazendaId: number;
  @Input() anoSafraStatus: number;
  @Input() culturaId: number;

  @Output() salvarEvento = new EventEmitter<number>();
  @Output() atualizarAnosSafra = new EventEmitter<number>();

  talhoes: any[] = [];
  planosMestrePorTalhao: { [key: string]: any[] } = {};
  variedadesPorTalhao: { [key: string]: any[] } = {};
  cultivarPorTalhao: { [key: string]: any } = {};
  processosPlanejamento: ProcessoPlanejamento[];
  loading = false;
  excluindoTalhao = false;
  originalTalhoes: any[] = [];
  projetosPorCultura: { [culturaId: number]: any[] } = {};
  culturas: any[] = [];
  culturasPlanejadas: Cultura[] = [];
  talhoesIrrigados: any[] = [];
  talhoesSequeiros: any[] = [];
  abaAtiva: "irrigado" | "sequeiro" = "irrigado";
  filtroNome: string = "";
  filtroStatus: string = "";
  talhoesIrrigadosFiltrados: any[] = [];
  talhoesSequeirosFiltrados: any[] = [];
  areaDisponivelInicialPorAreaId: { [areaId: number]: number } = {};
  alertMessage: string = "";
  alertType: "success" | "danger" = "success";
  talhoesLimpos: any[] = [];
  salvarAposConfirmacao = false;
  areaPlantadaInicialPorId: { [id: number]: number } = {};
  usarProjetos: boolean = false;
  ultimoAnoSafraIdCarregado: number | null = null;
  constructor(
    private planejamentoService: PlanejamentoService,
    private cultivarService: CultivarService,
    private culturaService: CulturaService,
    private storageService: StorageService,
    private etapaService: EtapaService,
    private processoPlanejamentoService: ProcessoPlanejamentoService,
    private utils: UtilsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

    this.loading = true;
    const anoSafraId = this.anoSafraId;
    const fazendaId = this.fazendaId;
    const culturaId = this.culturaId;
    this.usarProjetos = this.storageService.getEmpresa().UsaProjetos;
    if (!anoSafraId || !fazendaId) {
      this.loading = false;
      return;
    }
    this.culturaService.getCulturasPlanejadas().subscribe((culturas) => {
      this.culturasPlanejadas = culturas;
    });
    this.culturaService.getCulturas().subscribe((culturas) => {
      this.culturas = culturas;
    });
    this.planejamentoService
      .listarPorAnoSafraFazenda(anoSafraId, fazendaId)
      .subscribe((data) => {
        this.talhoes = JSON.parse(JSON.stringify(data));
        this.originalTalhoes = JSON.parse(JSON.stringify(data));
        this.ultimoAnoSafraIdCarregado = anoSafraId;

        this.talhoes.forEach((t) => {
          t.DataPrevistaPlantio = this.formatDateForInput(
            t.DataPrevistaPlantio
          );
          t.DataPrevistaColheita = this.formatDateForInput(
            t.DataPrevistaColheita
          );
          // Normalizar SafraId: se for 0, undefined ou null, deixar como null
          if (!t.SafraId || t.SafraId === 0) {
            t.SafraId = null;
          }
        });
        this.talhoesIrrigados = this.talhoes.filter(
          (t) => t.IsIrrigado || t.isIrrigado
        );
        this.talhoesSequeiros = this.talhoes.filter(
          (t) => !t.IsIrrigado && !t.isIrrigado
        );


        this.talhoes.forEach(t => {
          this.areaPlantadaInicialPorId[t.Id] = this.parseNumber(t.AreaPlantada);
        });

        const areaDisponivelPorAreaId: { [areaId: number]: number } = {};
        this.talhoes.forEach(t => {
          const areaId = t.AreaId;
          if (!areaDisponivelPorAreaId[areaId]) {
            const areaTotal = this.parseNumber(t.AreaTotal);
            const partes = this.getPartesTalhao(areaId);
            const somaPlantada = partes.reduce((acc, p) => acc + (this.parseNumber(p.AreaPlantada) || 0), 0);
            areaDisponivelPorAreaId[areaId] = areaTotal - somaPlantada;
          }
        });

        this.talhoes.forEach(t => {
          this.areaDisponivelInicialPorAreaId[t.AreaId] = areaDisponivelPorAreaId[t.AreaId];
        });

        this.aplicarFiltros();


        const culturasUnicas = [...new Set(this.talhoes.map(t => t.CulturaId).filter(id => id))];

        culturasUnicas.forEach(culturaId => {
          this.carregarProjetosParaCultura(culturaId);
        });


        let dependentes = 0;
        for (let t of this.talhoes) {
          if (!t.CulturaId) t.CulturaId = culturaId || null;
          this.carregarPlanosMestre(t, () => {
            dependentes--;
            if (dependentes <= 0) this.loading = false;
          });

          dependentes++;
        }
        if (dependentes === 0)
          this.loading = false;
      });

      this.processoPlanejamentoService.getProcessosPlanejamento()
      .subscribe(res => {
        this.processosPlanejamento = res;
      })
  }

  ngAfterViewInit(): void { }

  async fecharModal(): Promise<void> {

    if (this.ModalTalhoes) {
      this.limparFiltros();
      await this.atualizarAnosSafra.emit();
      this.ModalTalhoes.hide();

      this.limparEstado();
    }
  }

  private limparEstado(): void {
    this.projetosPorCultura = {};
    this.planosMestrePorTalhao = {};
    this.variedadesPorTalhao = {};
    this.cultivarPorTalhao = {};
    this.talhoes = [];
    this.talhoesIrrigados = [];
    this.talhoesSequeiros = [];
    this.talhoesIrrigadosFiltrados = [];
    this.talhoesSequeirosFiltrados = [];
    this.ultimoAnoSafraIdCarregado = null;
  }
  carregarPlanosMestre(t: any, cb?: () => void) {
    if (!t.CulturaId) {
      if (cb) cb();
      return;
    }

    const chave = this.getChaveTalhao(t);

    this.planejamentoService
      .listarPlanosMestrePorCultura(t.CulturaId)
      .subscribe((planos) => {
        this.planosMestrePorTalhao[chave] = planos;

        if (planos.length > 0) {
          t.CulturaString = planos[0].CulturaString || this.getCulturaString(t.CulturaId);
        }

        if (
          t.PlanoMestreProducaoId &&
          planos.some((p) => p.Id === t.PlanoMestreProducaoId)
        ) {
          this.carregarVariedades(t, cb);
        } else {
          this.variedadesPorTalhao[chave] = [];
          if (cb) cb();
        }
      }, (error) => {
        this.planosMestrePorTalhao[chave] = [];
        this.variedadesPorTalhao[chave] = [];
        if (cb) cb();
      });
  }

  carregarVariedades(t: any, cb?: () => void) {
    const chave = this.getChaveTalhao(t);

    if (!t.PlanoMestreProducaoId) {
      this.variedadesPorTalhao[chave] = [];
      if (cb) cb();
      return;
    }

    const plano = (this.planosMestrePorTalhao[chave] || []).find(
      (x) => x.Id === t.PlanoMestreProducaoId
    );

    let cultivarId = null;
    if (plano && plano.Cultivar && plano.Cultivar.Id !== undefined) {
      cultivarId = plano.Cultivar.Id;
    }

    if (!plano || cultivarId == null) {
      this.variedadesPorTalhao[chave] = [];
      if (cb) cb();
      return;
    }


    this.cultivarService
      .getCultivarPorCultivarBase(cultivarId)
      .subscribe((variedades) => {

        if (t.CultivarId && !variedades.some((v) => v.Id === t.CultivarId)) {
          this.cultivarService
            .getCultivar(t.CultivarId)
            .subscribe((cultivar) => {
              const nome =
                cultivar && cultivar.Nome
                  ? cultivar.Nome
                  : "Variedade desconhecida";
              variedades = [...variedades, { Id: t.CultivarId, Nome: nome }];
              this.variedadesPorTalhao[chave] = variedades;
              this.cultivarPorTalhao[chave] = cultivar;
              if (cb) cb();
            });
        } else {
          this.variedadesPorTalhao[chave] = variedades;
          if (t.CultivarId) {
            this.cultivarService
              .getCultivar(t.CultivarId)
              .subscribe((cultivar) => {
                this.cultivarPorTalhao[chave] = cultivar;
                if (cb) cb();
              });
          } else if (cb) cb();
        }
      }, (error) => {
        this.variedadesPorTalhao[chave] = [];
        if (cb) cb();
      });
  }

  onVariedadeChange(t: any) {
    if (!t.CultivarId) return;
    const chave = this.getChaveTalhao(t);

    this.cultivarService.getCultivar(t.CultivarId).subscribe((cultivar) => {
      this.cultivarPorTalhao[chave] = cultivar;

      if (t.DataPrevistaPlantio) {
        this.changePrevisaoPlantio(t, t.DataPrevistaPlantio);
      }
    });
  }

  isDataPrevistaPlantioFromList(talhao: any): boolean {
    const originalTalhao = this.originalTalhoes.find(
      (t) => t.AreaId === talhao.AreaId
    );
    return originalTalhao && originalTalhao.DataPrevistaPlantio != null;
  }

  changePrevisaoPlantio(t: any, dataPrevisao: any) {
    if (!dataPrevisao) {
      t.DataPrevistaColheita = null
      return;
    }

    let data: Date;
    if (dataPrevisao instanceof Date && !isNaN(dataPrevisao.getTime())) {
      data = dataPrevisao;
    } else if (typeof dataPrevisao === "string") {
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataPrevisao)) {
        const [day, month, year] = dataPrevisao.split('/');
        data = new Date(`${year}-${month}-${day}T00:00:00`);
      } else {
        data = new Date(dataPrevisao);
      }
    } else {
      return;
    }

    if (!(data instanceof Date) || isNaN(data.getTime())) return;

    if(t.DapPlanoAgronomico){
        const dataColheita = new Date(data);
        dataColheita.setDate(dataColheita.getDate() + t.DapPlanoAgronomico);
        t.DataPrevistaColheita = this.formatDateForInput(dataColheita)
    }else{
      const chave = this.getChaveTalhao(t);
      const cultivar = this.cultivarPorTalhao[chave];
      if (!cultivar) return;
      if (!cultivar.Ciclo || cultivar.Ciclo <= 0) return;

      t.DataPrevistaColheita = this.formatDateForInput(
        new Date(data.getTime() + cultivar.Ciclo * 24 * 60 * 60 * 1000)
      );
    }
  }

  cancelar() {
    this.talhoes = JSON.parse(JSON.stringify(this.originalTalhoes));
    this.fecharModal();

    this.planosMestrePorTalhao = {};
    this.variedadesPorTalhao = {};
    this.cultivarPorTalhao = {};
  }

  formatDateForInput(date: string | Date): string | null {
    if (!date) return null;

    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;

    return d.toISOString().slice(0, 10);
  }

  private formatDateForBackend(date: string): string | null {
    if (!date) return null;

    if (date.includes("T")) return date;

    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    return d.toISOString();
  }

  private parseNumber(val: any): number {
    if (typeof val === "number") return val;
    if (typeof val === "string") return Number(val.replace(",", "."));
    return Number(val);
  }

  private isGreater(a: number, b: number, epsilon = 0.00001): boolean {
    return a - b > epsilon;
  }

  private isTalhaoLimpo(t: any): boolean {
    const areaPlantadaOk = (!t.AreaPlantada || this.parseNumber(t.AreaPlantada) === 0);
    const cultivarOk = !t.CultivarId;
    const planoMestreOk = !t.PlanoMestreProducaoId;
    const safraOk = !t.SafraId;
    const dataPlantioOk = !t.DataPrevistaPlantio;
    const dataColheitaOk = !t.DataPrevistaColheita;

    return areaPlantadaOk && cultivarOk && planoMestreOk && safraOk && dataPlantioOk && dataColheitaOk;
  }

  private isStatusNaoConfigurado(t: any): boolean {
    return t.Status === 4;
  }

  private _round(num: any): number {
    const parsedNum = this.parseNumber(num);
    return Math.round((parsedNum + Number.EPSILON) * 10000) / 10000;
  }

  salvar() {
    this.marcarCamposObrigatoriosComoTocados();

    // Validação de datas
    const dataAtual = new Date();
    dataAtual.setHours(0, 0, 0, 0); // Zerar horas para comparar apenas datas

    const talhoesComErroData: any[] = [];

    this.talhoes.forEach(t => {
      // Validar apenas talhões que não estão em andamento ou colhidos
      if (t.Status === 2 || t.Status === 3) {
        return;
      }

      // Validar data de plantio
      if (t.DataPrevistaPlantio) {
        const dataPlantio = new Date(t.DataPrevistaPlantio);
        dataPlantio.setHours(0, 0, 0, 0);

        // Verificar se a data é válida
        if (isNaN(dataPlantio.getTime())) {
          talhoesComErroData.push({
            talhao: t,
            erro: 'Data de Previsão de Plantio inválida'
          });
          return;
        }

      }

      // Validar data de colheita
      if (t.DataPrevistaColheita) {
        const dataColheita = new Date(t.DataPrevistaColheita);
        dataColheita.setHours(0, 0, 0, 0);

        // Verificar se a data é válida
        if (isNaN(dataColheita.getTime())) {
          talhoesComErroData.push({
            talhao: t,
            erro: 'Data de Previsão de Colheita inválida'
          });
          return;
        }

        // Verificar se a data de colheita não é menor que a data de plantio
        if (t.DataPrevistaPlantio) {
          const dataPlantio = new Date(t.DataPrevistaPlantio);
          dataPlantio.setHours(0, 0, 0, 0);

          if (dataColheita < dataPlantio) {
            talhoesComErroData.push({
              talhao: t,
              erro: 'Data de Previsão de Colheita não pode ser menor que a Data de Previsão de Plantio'
            });
          }
        }
      }
    });

    // Se houver erros de data, exibir mensagem e interromper o salvamento
    if (talhoesComErroData.length > 0) {
      let htmlContent = '';
      talhoesComErroData.forEach(({ talhao, erro }) => {
        htmlContent += `
          <div style="margin-bottom:12px;">
            <b>Talhão:</b> ${talhao.Descricao || talhao.Id || 'Talhão sem descrição'}<br>
            <b>Erro:</b> <span style="color:#dc3545;">${erro}</span>
          </div>
        `;
      });
      Swal.fire({
        title: 'Erro na Validação de Datas',
        html: htmlContent,
        type: 'error',
        confirmButtonText: 'OK',
        customClass: {
          content: 'swal-scroll-content'
        }
      });
      return;
    }

    const talhoesParaValidar = this.talhoes.filter(t => [1, 4].includes(t.Status));

    const talhoesInvalidos = talhoesParaValidar
      .map((t, i) => ({ t, i }))
      .filter(({ t }) => {
        const areaTotal = this.parseNumber(t.AreaTotal);

        return this._round(t.AreaPlantada) > this._round(areaTotal);
      });

    const gruposInvalidos: { areaId: number, talhoesGrupo: any[], total: number, areaTotal: number }[] = Object.values(
      this.talhoes
        .filter(t => t.Status !== 2 && t.Status !== 3) // Excluir talhões em andamento (2) e colhidos (3) da validação
        .reduce((acc, t) => {
          const areaId = t.AreaId;

          if (!acc[areaId]) acc[areaId] = { areaId, talhoesGrupo: [], areaTotal: t.AreaTotal };
          acc[areaId].talhoesGrupo.push(t);
          return acc;
        }, {} as { [areaId: number]: { areaId: number, talhoesGrupo: any[], areaTotal: number } })
    ).map((grupo: { areaId: number, talhoesGrupo: any[], areaTotal: number }) => {
      const total = grupo.talhoesGrupo.reduce((acc, t) => acc + (this.parseNumber(t.AreaPlantada) || 0), 0);
      return { ...grupo, total };
    }).filter(grupo => grupo.total > grupo.areaTotal);

    if (talhoesInvalidos.length > 0 || gruposInvalidos.length > 0) {
      let htmlContent = '';
      talhoesInvalidos.forEach(({ t }) => {
        const areaTotal = this.parseNumber(t.AreaTotal);
        htmlContent += `
          <div style="margin-bottom:12px;">
            <b>Talhão:</b> ${t.Descricao || t.Id || 'Talhão sem descrição'}<br>
            <b>Área Total:</b> ${t.AreaTotal} Ha<br>
            <b>Área a Plantar:</b> ${t.AreaPlantada} Ha<br>
            <b>Área Disponível:</b> ${this._round(areaTotal - t.AreaPlantada)} Ha
          </div>
        `;
      });
      gruposInvalidos.forEach((grupo) => {
        const pai = grupo.talhoesGrupo[0];
        const subdivs = grupo.talhoesGrupo;
        const areaTotal = this.parseNumber(pai.AreaTotal);
        const areaDisponivelReal = areaTotal;
        const somaPlantio = grupo.total;
        const excesso = somaPlantio - areaTotal;
        const excessoMsg = excesso > 0 ? `<span style='color:#ffb141; font-size:14px;'>⚠️</span> <i style='font-size:12px;'>A área solicitada para plantio nas subdivisões ultrapassa a área total em <b>${excesso} ha</b>.<br>Área Total ${areaTotal} ha</i>` : '';
        const linhasSubdiv = subdivs.map((t, idx) => {
          const dentroLimite = somaPlantio <= areaTotal;
          const obs = dentroLimite
            ? `<span style='color:#1ecb4f;'>✅ Dentro da área disponível</span>`
            : `<span style='color:#ffb141;'>⚠️ Ultrapassa o limite (total ${somaPlantio} ha > ${areaTotal} ha)</span>`;
          return `
            <tr>
              <td>${t.Descricao}${subdivs.length > 1 ? ` (${String.fromCharCode(65 + idx)})` : ''}</td>
              <td>${t.AreaPlantada} ha</td>
              <td>${obs}</td>
            </tr>
          `;
        }).join('');
        htmlContent += `
          <div style="margin-bottom:12px;">
            <div style="display:flex;gap:24px;margin-bottom:8px;">
              <div style="flex:1;min-width:120px;">
                <div style="font-size:14px;"><b>Talhão Principal:</b> ${pai.Descricao}</div>
                <div style="font-size:14px;"><b>Área Total:</b> ${areaTotal} ha</div>
              </div>
              <div style="flex:1;min-width:120px;">
                <div style="font-size:14px;"><b>Área Solicitada para Plantio:</b> ${somaPlantio} ha ${excesso > 0 ? `<span style='color:#ffb141;'>⚠️</span>` : ''}</div>
              </div>
            </div>
            ${excessoMsg ? `<div style='margin-bottom:12px;'>${excessoMsg}</div>` : ''}
            <div style="font-weight:600;margin-bottom:4px;"><span style='font-size:1.1em;'>🔍</span> Detalhamento das Subdivisões</div>
            <table border="1" style="width:100%;text-align:left;font-size:13px;border-collapse:collapse;">
              <thead><tr><th>Subdivisão</th><th>Área Solicitada</th><th>Observações</th></tr></thead>
              <tbody>${linhasSubdiv}</tbody>
            </table>
          </div>
        `;
      });
      Swal.fire({
        title: 'Talhões com Área a Plantar maior que a disponível',
        html: htmlContent,
        type: 'warning',
        confirmButtonText: 'OK',
        customClass: {
          content: 'swal-scroll-content'
        }
      });
      return;
    }

    this.talhoesLimpos = this.talhoes.filter(t => {
      const isLimpo = this.isTalhaoLimpo(t);
      const isNaoConfigurado = this.isStatusNaoConfigurado(t);
      return isLimpo && !isNaoConfigurado;
    });

    if (this.talhoesLimpos.length > 0 && !this.salvarAposConfirmacao) {
      Swal.fire({
        title: 'Atenção',
        html: `Há talhões que foram limpos e não configurados.<br>Tem certeza que deseja continuar?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, continuar',
        cancelButtonText: 'Não',
      }).then(result => {
        if (!result.dismiss) {
          this.salvarAposConfirmacao = true;
          this.salvar();
        }
      });
      return;
    }

    // Filtrar apenas talhões editáveis (NÃO enviar Em Andamento ou Colhidos)
    const talhoesEditaveis = this.talhoes.filter(t => {
      // NÃO enviar talhões já em andamento (Status 2) ou colhidos (Status 3)
      if (t.Status === 2 || t.Status === 3) {
        return false;
      }

      // Incluir apenas se tiver algum dado preenchido OU seja novo (Id = 0)
      const temAlgumDado = this.temAlgumCampoPreenchido(t);
      const ehNovo = !t.Id || t.Id === 0;

      return temAlgumDado || ehNovo;
    });

    // Preparar dados apenas dos talhões editáveis
    let talhoesParaSalvar = talhoesEditaveis.map((t) => {
      const { _variedadeTouched, _previsaoPlantioTouched, _previsaoColheitaTouched, _modificado, _parteNova, DapPlanoAgronomico, ...talhaoLimpo } = t;

      return {
        ...talhaoLimpo,
        AreaPlantada: typeof t.AreaPlantada === 'string' ? parseFloat(t.AreaPlantada.replace(',', '.')) : Number(t.AreaPlantada),
        DataPrevistaPlantio: t.DataPrevistaPlantio ? this.formatDateForBackend(t.DataPrevistaPlantio) : null,
        DataPrevistaColheita: t.DataPrevistaColheita ? this.formatDateForBackend(t.DataPrevistaColheita) : null,
        SafraId: t.SafraId && t.SafraId > 0 ? t.SafraId : null,
      };
    });

    this.loading = true;
    let talhoesParaEnviar: Planejamento[] = [];
    talhoesParaSalvar.forEach(x => {
      if (x.CultivarId === null || x.CultivarId === undefined)
        x.CultivarId = 0;
      if (x.CulturaId === null || x.CulturaId === undefined)
        x.CulturaId = 0;

      talhoesParaEnviar.push(x);
    });

    this.planejamentoService.salvarPlanejamentosPorTalhao(
      this.anoSafraId,
      this.fazendaId,
      talhoesParaEnviar
    ).subscribe(
      () => {
        this.loading = false;
        this.utils.handleSuccess('Talhões salvos com sucesso!');
        this.fecharModal();
        this.salvarAposConfirmacao = false;
      },
      (err) => {
        this.loading = false;
        this.utils.getErro(err);
        this.salvarAposConfirmacao = false;
      }
    );
  }

  logTalhao(t: any, i: number) {
    return "";
  }

  aplicarFiltros() {

    this.talhoesIrrigadosFiltrados = this.talhoesIrrigados.filter((talhao) => {
      const nomeOk =
        !this.filtroNome ||
        (talhao.Descricao &&
          talhao.Descricao.toLowerCase().includes(
            this.filtroNome.toLowerCase()
          ));
      const statusOk = !this.filtroStatus || talhao.Status == this.filtroStatus;
      return nomeOk && statusOk;
    });
    this.talhoesSequeirosFiltrados = this.talhoesSequeiros.filter((talhao) => {
      const nomeOk =
        !this.filtroNome ||
        (talhao.Descricao &&
          talhao.Descricao.toLowerCase().includes(
            this.filtroNome.toLowerCase()
          ));
      const statusOk = !this.filtroStatus || talhao.Status == this.filtroStatus;
      return nomeOk && statusOk;
    });

  }

  limparFiltros() {
    this.filtroNome = "";
    this.filtroStatus = "";
    this.aplicarFiltros();
  }

  getLetraParte(talhao: any): string {
    const partes = this.getPartesTalhao(talhao.AreaId);
    if (partes.length <= 1) return "";
    const idx = partes.findIndex((p) => p === talhao);
    if (idx === 0) return "";
    return String.fromCharCode(64 + idx);
  }

  getPartesTalhao(areaId: number): any[] {
    return this.talhoes.filter((t) => t.AreaId === areaId);
  }

  getChaveTalhao(talhao: any): string {
    return `${talhao.AreaId}_${talhao.Descricao}_${talhao.Id}`;
  }

  getCulturaString(culturaId: number): string {
    const culturas = {
      1: 'Soja',
      3: 'Feijão',
      7: 'Algodão'
    };
    return culturas[culturaId] || 'Cultura Desconhecida';
  }

  getProjetosParaTalhao(talhao: any): any[] {
    if (!talhao.CulturaId) return [];

    const projetos = this.projetosPorCultura[talhao.CulturaId];
    if (projetos) {
      return projetos;
    }

    return [];
  }

  onProjetoChange(talhao: any) {
    // Normalizar SafraId: se for 0, undefined ou null, deixar como null
    if (!talhao.SafraId || talhao.SafraId === 0) {
      talhao.SafraId = null;
    }
  }


  hasAreasInvalidas(): boolean {

    const talhoesEditaveis = this.talhoes.filter(t => [1, 4].includes(t.Status));

    const talhoesInvalidos = talhoesEditaveis
      .filter(t => {
        const areaTotal = this.parseNumber(t.AreaTotal);
        return this._round(t.AreaPlantada) > this._round(areaTotal);
      });

    const gruposInvalidos = Object.values(
      talhoesEditaveis.reduce((acc, t) => {
        const areaId = t.AreaId;
        if (!acc[areaId]) acc[areaId] = { areaId, talhoesGrupo: [], areaTotal: t.AreaTotal };
        acc[areaId].talhoesGrupo.push(t);
        return acc;
      }, {} as { [areaId: number]: { areaId: number, talhoesGrupo: any[], areaTotal: number } })
    ).map((grupo: { areaId: number, talhoesGrupo: any[], areaTotal: number }) => {
      const total = grupo.talhoesGrupo.reduce((acc, t) => acc + (this.parseNumber(t.AreaPlantada) || 0), 0);
      return { ...grupo, total };
    }).filter(grupo => grupo.total > grupo.areaTotal);


    const temCamposObrigatoriosVazios = this.hasCamposObrigatoriosVazios();

    return talhoesInvalidos.length > 0 || gruposInvalidos.length > 0 || temCamposObrigatoriosVazios;
  }

  getAreaDisponivelGrupo(talhao: any): number {
    const partes = this.getPartesTalhao(talhao.AreaId);
    const areaTotal = this.parseNumber(talhao.AreaTotal);
    const somaPlantada = partes.reduce((acc, p) => acc + (this.parseNumber(p.AreaPlantada) || 0), 0);

    return Math.max(0, this._round(areaTotal - somaPlantada));
  }

  getAreaDisponivelParte(talhao: any): number {
    const partes = this.getPartesTalhao(talhao.AreaId);
    const areaTotal = this.parseNumber(talhao.AreaTotal);
    const somaOutras = partes.filter((p) => p !== talhao).reduce((acc, p) => acc + (this.parseNumber(p.AreaPlantada) || 0), 0);

    return Math.max(0, this._round(areaTotal - somaOutras));
  }

  getAreaDisponivelMaximaParte(talhao: any): number {
    return this.getAreaDisponivelParte(talhao);
  }

  getAreaDisponivelInicial(talhao: any): number {
    const partes = this.getPartesTalhao(talhao.AreaId);
    const areaTotal = this.parseNumber(talhao.AreaTotal);
    const somaPlantada = partes.reduce((acc, p) => acc + (this.parseNumber(p.AreaPlantada) || 0), 0);

    return Math.max(0, this._round(areaTotal - somaPlantada));
  }

  copiarTalhao(talhao: any) {
    const partes = this.getPartesTalhao(talhao.AreaId);

    const descricaoBase = talhao.Descricao.replace(/ [A-Z]$/, "");

    const letrasUsadas = partes.map(p => {
      const match = p.Descricao.match(/ ([A-Z])$/);
      return match ? match[1] : null;
    }).filter(letra => letra !== null);

    let proximaLetra = 'A';
    for (let i = 0; i < 26; i++) {
      const letra = String.fromCharCode(65 + i);
      if (!letrasUsadas.includes(letra)) {
        proximaLetra = letra;
        break;
      }
    }

    const novo = JSON.parse(JSON.stringify(talhao));
    novo.Id = 0;
    novo.AreaPlantada = this.getAreaDisponivelGrupo(talhao);
    novo.CultivarId = null;
    novo.PlanoMestreProducaoId = null;
    novo.SafraId = null;
    novo.DataPrevistaPlantio = null;
    novo.DataPrevistaColheita = null;
    novo._parteNova = true;
    novo.Status = 4;
    novo.DescricaoStatus = 'Não Configurada';

    novo.Descricao = descricaoBase + " " + proximaLetra;

    const idx = this.talhoes.lastIndexOf(partes[partes.length - 1]);
    this.talhoes.splice(idx + 1, 0, novo);
    this.reaplicarFiltros();

    if (novo.CulturaId) {
      this.carregarPlanosMestre(novo);
      this.carregarProjetosParaCultura(novo.CulturaId);
    }
  }

  excluirParteTalhao(talhao: any) {
    const partes = this.getPartesTalhao(talhao.AreaId);
    if (partes[0] !== talhao) {
      this.excluirTalhaoFilho(talhao);
    } else {
      this.excluirTalhaoPai(talhao);
    }
  }

  excluirTalhaoPai(talhao: any) {
    this.excluindoTalhao = true;

    talhao.AreaPlantada = 0;
    talhao.CultivarId = 0;
    talhao.PlanoMestreProducaoId = 0;
    talhao.SafraId = null;
    talhao.CulturaId = 0;
    talhao.DataPrevistaPlantio = null;
    talhao.DataPrevistaColheita = null;

    if (talhao.Id && talhao.Id > 0) {
      this.planejamentoService.deletePlanejamento(talhao.Id).subscribe({
        next: (response) => {
          this.atualizarListaTalhoes();
        },
        error: (error) => {
          this.atualizarListaTalhoes();
        }
      });
    } else {
      this.excluindoTalhao = false;
    }
  }

  excluirTalhaoFilho(talhao: any) {
    this.excluindoTalhao = true;

    this.talhoes = this.talhoes.filter(t => t !== talhao);
    this.reaplicarFiltros();


    if (talhao.Id && talhao.Id > 0) {
      this.planejamentoService.deletePlanejamento(talhao.Id).subscribe({
        next: (response) => {
          this.atualizarListaTalhoes();
        },
        error: (error) => {
          this.atualizarListaTalhoes();
        }
      });
    } else {
      this.excluindoTalhao = false;
    }
  }

  atualizarListaTalhoes() {
    this.planejamentoService
      .listarPorAnoSafraFazenda(this.anoSafraId, this.fazendaId)
      .subscribe((data) => {
        this.talhoes = JSON.parse(JSON.stringify(data));
        this.originalTalhoes = JSON.parse(JSON.stringify(data));

        this.talhoes.forEach((t) => {
          t.DataPrevistaPlantio = this.formatDateForInput(
            t.DataPrevistaPlantio
          );
          t.DataPrevistaColheita = this.formatDateForInput(
            t.DataPrevistaColheita
          );
          // Normalizar SafraId: se for 0, undefined ou null, deixar como null
          if (!t.SafraId || t.SafraId === 0) {
            t.SafraId = null;
          }
        });
        this.talhoesIrrigados = this.talhoes.filter(
          (t) => t.IsIrrigado || t.isIrrigado
        );
        this.talhoesSequeiros = this.talhoes.filter(
          (t) => !t.IsIrrigado && !t.isIrrigado
        );

        this.aplicarFiltros();
        this.excluindoTalhao = false;
      });
  }

  reaplicarFiltros() {

    this.talhoesIrrigados = this.talhoes.filter(
      (t) => t.IsIrrigado || t.isIrrigado
    );
    this.talhoesSequeiros = this.talhoes.filter(
      (t) => !t.IsIrrigado && !t.isIrrigado
    );
    this.aplicarFiltros();

  }

  trocarAba(novaAba: "irrigado" | "sequeiro") {
    if (this.abaAtiva === novaAba) return;


    this.abaAtiva = novaAba;

    this.cdr.detectChanges();
  }


  getStatusLabel(status: number): string {
    switch (status) {
      case 0:
        return "Configurada";
      case 1:
        return "Em Planejamento";
      case 2:
        return "Em Andamento";
      case 3:
        return "Colhido";
      case 4:
        return "Não Configurada";
      default:
        return "Desconhecido";
    }
  }

  isTalhaoReadOnly(talhao: any): boolean {
    return [2, 3].includes(talhao.Status);
  }

  isTalhaoLimpoParaExclusao(talhao: any): boolean {

    return this.isTalhaoLimpo(talhao);
  }

  onPlanoMestreChange(t: Planejamento) {
    const chave = this.getChaveTalhao(t);

    t.CultivarId = null;
    this.variedadesPorTalhao[chave] = [];

    t.DataPrevistaPlantio = null;
    t.DataPrevistaColheita = null;

    const planos = this.planosMestrePorTalhao[chave];
    if (planos && planos.length > 0) {
      const planoSelecionado = planos.find(p => p.Id === t.PlanoMestreProducaoId);
      if (planoSelecionado) {
        t.DescricaoPlanoMestreProducao = planoSelecionado.Descricao;
      }
    }

    this.carregarVariedades(t);

    if(t.PlanoMestreProducaoId){
      const plano = this.planosMestrePorTalhao[chave].find(p => p.Id == t.PlanoMestreProducaoId)
      this.etapaService.getAuxEtapas(t.PlanoMestreProducaoId)
      .subscribe((res: AuxEtapa[]) => {

        let etapasColheita = res.filter(et => {
          const processoPlanejamento = this.processosPlanejamento.find(p => p.Id == et.ProcessoPlanejamentoId);
          return processoPlanejamento && processoPlanejamento.Colheita;
        });
        t.DapPlanoAgronomico = etapasColheita.length > 0
           ? Math.max(...etapasColheita.map((obj: AuxEtapa) => obj.DiasAposPlantio))
           : null;
      })
    }
  }

  onCulturaChange(t: any) {
    const chave = this.getChaveTalhao(t);

    t.PlanoMestreProducaoId = null;
    t.CultivarId = null;
    t.DataPrevistaPlantio = null;
    t.DataPrevistaColheita = null;
    t.CulturaString = null;
    t.DescricaoPlanoMestreProducao = null;

    this.planosMestrePorTalhao[chave] = [];
    this.variedadesPorTalhao[chave] = [];

    if (t.CulturaId) {
      this.carregarPlanosMestre(t);
      this.carregarProjetosParaCultura(t.CulturaId);
    }
  }

  private carregarProjetosParaCultura(culturaId: number): void {
    if (this.projetosPorCultura[culturaId]) {
      return;
    }

    this.planejamentoService
      .listarProjetos(this.anoSafraId, culturaId)
      .subscribe((projetos) => {
        this.projetosPorCultura[culturaId] = projetos;
      }, (error) => {
        this.projetosPorCultura[culturaId] = [];
      });
  }

  ngOnChanges(changes: SimpleChanges): void { }

  isDataPrevistaPlantioDisabled(talhao: any): boolean {
    if (talhao.Status === 2 || talhao.Status === 3) return true;
    return !talhao.CultivarId;
  }
  isDataPrevistaColheitaDisabled(talhao: any): boolean {
    return !talhao.DataPrevistaPlantio || !!talhao.DapPlanoAgronomico;
  }

  abrirModal() {

    if (!this.anoSafraId || !this.fazendaId) {
      return;
    }

    const deveRecarregar = this.talhoes.length === 0 ||
                          this.ultimoAnoSafraIdCarregado !== this.anoSafraId;

    if (deveRecarregar) {
      this.ngOnInit();
    }

    this.ModalTalhoes.show();
  }

  formatarAreaPlantada(valor: any): string {
    if (valor === null || valor === undefined || valor === '') return '';
    return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  onAreaPlantadaInput(event: any, talhao: any) {
    let valor = event.target.value;
    valor = valor.replace(/\D/g, '');
    while (valor.length < 3) valor = '0' + valor;
    let parteInteira = valor.slice(0, valor.length - 2);
    let parteDecimal = valor.slice(-2);
    parteInteira = parteInteira.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    event.target.value = parteInteira + ',' + parteDecimal;
    talhao.AreaPlantada = parseFloat((parteInteira.replace(/\./g, '') + '.' + parteDecimal));

    setTimeout(() => {

      this.cdr.detectChanges();
    }, 0);
  }

  onAreaPlantadaBlur(talhao: any) {
    if (talhao.AreaPlantada !== null && talhao.AreaPlantada !== undefined && !isNaN(talhao.AreaPlantada)) {
      talhao.AreaPlantada = parseFloat(talhao.AreaPlantada).toFixed(2);
    } else {
      talhao.AreaPlantada = null;
    }

    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  isAreaPlantadaInvalidaCampo(talhao: any): boolean {
    const partes = this.getPartesTalhao(talhao.AreaId);
    const areaTotal = this.parseNumber(talhao.AreaTotal);
    if (partes.length === 1) {

      return this._round(talhao.AreaPlantada) > this._round(areaTotal);
    } else {

      const somaPlantada = partes.reduce((acc, t) => acc + (this.parseNumber(t.AreaPlantada) || 0), 0);
      return this._round(somaPlantada) > this._round(areaTotal);
    }
  }

  isTalhaoComCamposObrigatorios(talhao: any): boolean {
    if (![1, 4].includes(talhao.Status)) {
      return true;
    }

    const temAlgumCampo = this.temAlgumCampoPreenchido(talhao);
    if (!temAlgumCampo) {
      return true;
    }

    const camposObrigatoriosOk = this.temTodosCamposObrigatoriosPreenchidos(talhao);
    const dataColheitaValida = this.isDataColheitaValida(talhao);

    return camposObrigatoriosOk && dataColheitaValida;
  }

  private temTodosCamposObrigatoriosPreenchidos(talhao: any): boolean {

    if (!talhao.AreaPlantada || this.parseNumber(talhao.AreaPlantada) <= 0) {
      return false;
    }

    if (!talhao.CulturaId) {
      return false;
    }

    if (!talhao.PlanoMestreProducaoId) {
      return false;
    }

    if (!talhao.CultivarId) {
      return false;
    }

    if (!talhao.DataPrevistaPlantio) {
      return false;
    }

    if (!talhao.DataPrevistaColheita) {
      return false;
    }

    return true;
  }

  private temAlgumCampoPreenchido(talhao: any): boolean {
    return !!(talhao.AreaPlantada && this.parseNumber(talhao.AreaPlantada) > 0) ||
           !!talhao.CulturaId ||
           !!talhao.PlanoMestreProducaoId ||
           !!talhao.CultivarId ||
           !!talhao.DataPrevistaPlantio ||
           !!talhao.DataPrevistaColheita;
  }

  hasCamposObrigatoriosVazios(): boolean {
    const talhoesEditaveis = this.talhoes.filter(t => [1, 4].includes(t.Status));
    return talhoesEditaveis.some(t => !this.isTalhaoComCamposObrigatorios(t));
  }

  isCampoObrigatorioVazio(talhao: any, campo: string): boolean {
    if (![1, 4].includes(talhao.Status)) {
      return false;
    }

    const temAlgumCampo = this.temAlgumCampoPreenchido(talhao);
    if (!temAlgumCampo) {
      return false;
    }

    if (campo === 'plantio' && this.isDataPlantioInvalida(talhao)) {
      return false;
    }

    if (campo === 'colheita' && this.isDataColheitaInvalidaAno(talhao)) {
      return false;
    }

    return this.isCampoVazio(talhao, campo);
  }

  isDataColheitaInvalida(talhao: any): boolean {
    if (![1, 4].includes(talhao.Status)) {
      return false;
    }

    const temAlgumCampo = this.temAlgumCampoPreenchido(talhao);
    if (!temAlgumCampo) {
      return false;
    }

    if (!this.isAnoValido(talhao.DataPrevistaColheita)) {
      return false;
    }

    return !this.isDataColheitaValida(talhao);
  }

  private isCampoVazio(talhao: any, campo: string): boolean {
    switch (campo) {
      case 'variedade':
        return !talhao.CultivarId;
      case 'plantio':
        return !talhao.DataPrevistaPlantio;
      case 'colheita':
        return !talhao.DataPrevistaColheita;
      default:
        return false;
    }
  }

  private isDataColheitaValida(talhao: any): boolean {
    if (!talhao.DataPrevistaPlantio || !talhao.DataPrevistaColheita) {
      return true;
    }

    const dataPlantio = new Date(talhao.DataPrevistaPlantio);
    const dataColheita = new Date(talhao.DataPrevistaColheita);

    return dataColheita > dataPlantio;
  }

  private isAnoValido(data: string): boolean {
    if (!data) return true;

    const dataObj = new Date(data);
    const ano = dataObj.getFullYear();

    return ano >= 1900 && ano <= 2100 && !isNaN(ano);
  }

  private isDataPlantioInvalida(talhao: any): boolean {
    if (![1, 4].includes(talhao.Status)) {
      return false;
    }

    const temAlgumCampo = this.temAlgumCampoPreenchido(talhao);
    if (!temAlgumCampo) {
      return false;
    }

    return !this.isAnoValido(talhao.DataPrevistaPlantio);
  }

  private isDataColheitaInvalidaAno(talhao: any): boolean {
    if (![1, 4].includes(talhao.Status)) {
      return false;
    }

    const temAlgumCampo = this.temAlgumCampoPreenchido(talhao);
    if (!temAlgumCampo) {
      return false;
    }

    return !this.isAnoValido(talhao.DataPrevistaColheita);
  }

  onDataClear(talhao: any, campo: string) {
    switch (campo) {
      case 'plantio':
        talhao._previsaoPlantioTouched = true;
        break;
      case 'colheita':
        talhao._previsaoColheitaTouched = true;
        break;
    }
  }

  onVariedadeClear(talhao: any) {
    talhao._variedadeTouched = true;

    talhao.DataPrevistaPlantio = null;
    talhao.DataPrevistaColheita = null;
  }

  marcarCamposObrigatoriosComoTocados() {
    this.talhoes.forEach(talhao => {
      if ([1, 4].includes(talhao.Status)) {

        talhao._variedadeTouched = true;
        talhao._previsaoPlantioTouched = true;
        talhao._previsaoColheitaTouched = true;
      }
    });
  }
}
